/**
 * Create System Setting context for custom hook
 */
import { createContext } from 'react'

const OrdersContext = createContext({
  fetchOrders: () => {},
  fetchOrder: () => {},
  fetchOrderByReferenceNumber: () => {},
  fetchOrderByUuid: () => {},
  updateOrder: () => {},
  updateOrderToDecline: () => {}
})

export default OrdersContext
